import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import index from '@/view/index'
import register from '@/view/register'
import forget from '@/view/forget'
import address from '@/view/address'
import user from '@/user/user'
import userInfo from '@/user/userInfo'
import balance from '@/user/balance'
import transfer from '@/user/transfer'
import withdrawal from '@/user/withdrawal'
import recharge from '@/user/recharge'
import language from '@/user/language'
import setting from '@/user/setting'
import asset from '@/user/asset'
import login from '@/user/login'
import details from '@/luckyhash/details'
import luckyhash from '@/luckyhash/luckyhash'
import exchangeRecord from '@/user/exchangeRecord'
import withdrawalRecord from '@/user/withdrawalRecord'
import bettingRecord from '@/user/bettingRecord'
import spread from '@/spread/spread'
import performance from '@/spread/performance'
import help from '@/help/help'
import lotteryRecord from '@/help/lotteryRecord'
import notice from '@/notice/notice'
import noticeDetails from '@/notice/noticeDetails'
import question from '@/notice/question'
import history from '@/luckyhash/history'
import entertainment from '@/luckyhash/entertainment'
import forrecord from '@/user/forrecord'
import transactiondetails from '@/user/transactiondetails'
import add_address from '@/user/add_address'
import Privacypolicy from '@/view/Privacypolicy'
import myteam from '@/user/myteam'
import phone from '@/user/phone'
import guide from '@/help/guide'
import vip from '@/spread/vip'
import rules from '@/spread/rules'
import shangchuan from '@/user/shangchuan'
Vue.use(Router)
axios.interceptors.request.use(
  config => {
    //console.log(config)
    if (localStorage.getItem("token")) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = `${localStorage.getItem("token")}`;
    } else {
      config.headers.token = ''
    }
    if (localStorage.getItem("language") == 'Chinese') {
      config.headers.lang = '1'//后端返回提示语言类型 简体中文
    } else if (localStorage.getItem("language") == 'English') {
      config.headers.lang = '2'//后端返回提示语言类型 英文
    } else if (localStorage.getItem("language") == 'Traditional') {
      config.headers.lang = '3'//后端返回提示语言类型 繁体中文
    } else if (localStorage.getItem("language") == 'Japanese') {
      config.headers.lang = '4'//后端返回提示语言类型 日语
    } else if (localStorage.getItem("language") == 'Vietnamese') {
      config.headers.lang = '5'//后端返回提示语言类型 越南语
    } else if (localStorage.getItem("language") == 'Malay') {
      config.headers.lang = '6'//后端返回提示语言类型 马来语
    } else if (localStorage.getItem("language") == 'Hindi') {
      config.headers.lang = '7'//后端返回提示语言类型 印度语
    } else if (localStorage.getItem("language") == 'Thai') {
      config.headers.lang = '8'//后端返回提示语言类型 泰语
    } else if (localStorage.getItem("language") == 'Russian') {
      config.headers.lang = '9'//后端返回提示语言类型 俄语
    } else if (localStorage.getItem("language") == 'Indonesian') {
      config.headers.lang = '10'//后端返回提示语言类型 印尼语
    }

    //config.headers.ContentType = 'application/x-www-form-urlencoded';
    return config;
  },
  err => {
    return Promise.reject(err);
  });
export default new Router({
  routes: [
    { path: '/', redirect: '/luckyhash' },
    {
      path: '/luckyhash',
      name: 'luckyhash',
      component: luckyhash,
      meta: {
        keepAlive: true, //此组件不需要被缓存
      },
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/forget',
      name: 'forget',
      component: forget
    },
    {
      path: '/address',
      name: 'address',
      component: address
    },
    {
      path: '/user',
      name: 'user',
      component: user,
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo
    },
    {
      path: '/balance',
      name: 'balance',
      component: balance
    },
    {
      path: '/transfer',
      name: 'transfer',
      component: transfer
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge
    },
    {
      path: '/language',
      name: 'language',
      component: language
    },
    {
      path: '/setting',
      name: 'setting',
      component: setting
    },
    {
      path: '/asset',
      name: 'asset',
      component: asset
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/exchangeRecord',
      name: 'exchangeRecord',
      component: exchangeRecord
    },
    {
      path: '/withdrawalRecord',
      name: 'withdrawalRecord',
      component: withdrawalRecord
    },
    {
      path: '/bettingRecord',
      name: 'bettingRecord',
      component: bettingRecord
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },

    {
      path: '/spread',
      name: 'spread',
      component: spread
    },
    {
      path: '/performance',
      name: 'performance',
      component: performance
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/lotteryRecord',//开奖记录
      name: 'lotteryRecord',
      component: lotteryRecord
    },
    {
      path: '/notice',//公告列表
      name: 'notice',
      component: notice
    },
    {
      path: '/noticeDetails',//公告详情
      name: 'noticeDetails',
      component: noticeDetails
    },
    {
      path: '/question',//常见问题
      name: 'question',
      component: question
    },
    {
      path: '/history',
      name: 'history',
      component: history
    },
    {
      path: '/entertainment',
      name: 'entertainment',
      component: entertainment
    },
    {
      path: '/forrecord', //兑换记录
      name: 'forrecord',
      component: forrecord
    },
    {
      path: '/transactiondetails', //交易明细
      name: 'transactiondetails',
      component: transactiondetails
    },
    {
      path: '/add_address', //添加钱包
      name: 'add_address',
      component: add_address
    },
    {
      path: '/Privacypolicy', //隐私政策
      name: 'Privacypolicy',
      component: Privacypolicy
    },
    {
      path: '/myteam', //我的团队
      name: 'myteam',
      component: myteam
    },
    {
      path: '/phone', //我的手机
      name: 'phone',
      component: phone
    },
    {
      path: '/guide', //我的手机
      name: 'guide',
      component: guide
    },
    {
      path: '/vip', //我的手机
      name: 'vip',
      component: vip
    },
    {
      path: '/rules', //我的手机
      name: 'rules',
      component: rules
    },
    {
      path: '/shangchuan', //我的手机
      name: 'shangchuan',
      component: shangchuan
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js